import {translate} from 'vue-gettext';

const {gettext: $gettext, pgettext: $pgettext, gettextInterpolate: $gettextInterpolate} = translate;
import {helpers, minLength, required, email, sameAs} from '@vuelidate/validators'


function inArray$1(arr) {
    return value => !helpers.req(value) || arr.includes(value)
}

function inArray(arr) {
    return {
        $validator: inArray$1(arr),
        $message: _ref => {
            let {
                $params
            } = _ref;
            return `Allowed values are: ${$params.arr.join(', ')}`;
        },
        $params: {
            arr,
            type: 'inArray'
        }
    };
}

const htmlColor = (value) => !helpers.req(value) || CSS.supports('color', value)

const required$ = helpers.withMessage($pgettext('validation.error', 'Required field'), required)
const email$ = helpers.withMessage($pgettext('validation.error', 'Invalid email'), email)
const minLength$ = (min) => helpers.withMessage(
    ({$params}) => $gettextInterpolate($gettext(`Type at least %{min} characters`), {min: $params.min}), minLength(min)
)
const sameAs$ = (field, otherName) => helpers.withMessage(
    ({$params}) => $gettextInterpolate($gettext(`This field should be the same as %{field}`), {field: $params.otherName}), sameAs(field, otherName)
)

const containsDigits$ = (min, fieldName) => helpers.withMessage(
    () => $gettextInterpolate(
        $gettext('%{field} must contain at least %{min} digits'),
        {field: fieldName, min: min}
    ),
    (value) => {
        if (!helpers.req(value)) return true;
        const digitMatches = value.match(/\d/g)
        return digitMatches && digitMatches.length >= min
    }
)
const containsUppercase$ = (min, fieldName) => helpers.withMessage(
    () => $gettextInterpolate(
        $gettext('%{field} must contain at least %{min} uppercase character'),
        {field: fieldName, min: min}
    ),
    (value) => {
        if (!helpers.req(value)) return true
        const uppercaseMatches = value.match(/[A-Z]/g)
        return uppercaseMatches && uppercaseMatches.length >= min
    }
)
const containsLowercase$ = (min, fieldName) => helpers.withMessage(
    () => $gettextInterpolate(
        $gettext('%{field} must contain at least %{min} lowercase character'),
        {field: fieldName, min: min}
    ),
    (value) => {
        if (!helpers.req(value)) return true
        const lowercaseMatches = value.match(/[a-z]/g)
        return lowercaseMatches && lowercaseMatches.length >= min
    }
)
const containsChars$ = (chars, fieldName) => {
    return helpers.withMessage(
        () => $gettextInterpolate(
            $gettext('%{field} must contain 1 special character: %{chars}'),
            {field: fieldName, chars: chars}
        ),
        (value) => {
            if (!helpers.req(value)) return true
            const charMatches = value.match(new RegExp(`[${chars}]`, 'g'))
            return charMatches && charMatches.length > 0
        }
    )
}
export {
    inArray,
    htmlColor,
    required$,
    email$,
    minLength$,
    sameAs$,
    containsUppercase$,
    containsLowercase$,
    containsDigits$,
    containsChars$
}